import parse from 'html-react-parser'
import styles from './IconBadge.module.scss'
import { Button, Icon, Tooltip } from '@boltenergy-be/design-system'
import { IconBadgeProps } from 'components/icon-badge/types'

const IconBadge = ({ actionButton, icon, label, tooltipContent }: IconBadgeProps) => {
  return (
    <div className={styles['usage-indicator']}>
      <Tooltip {...{ tooltipContent }} asChild>
        <span className={styles['usage-content']} tabIndex={0}>
          <Icon name={icon} className={styles.icon} size={16} /> {parse(label)}
        </span>
      </Tooltip>{' '}
      {actionButton && (
        <Button size="small" variant="tertiary" leadingIcon={actionButton.icon} onClick={actionButton.onClick} title="reset" />
      )}
    </div>
  )
}

export default IconBadge
